export default __webpack_public_path__ + "static/crossword_study-6da6b9cbe6d1b8a8c5e8b19bcbb268e4.svg";